<template>
  <section>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :footer-props="tableFooter"
      locale="pt-pt"
    >
      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:item.username="{ item }">
        {{ item.username || "-" }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              small
              @click="downloadPrint(item)"
            >
              <v-icon small>mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Descarregar impressão</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import GarantiasRetencoes from "@/api/GarantiasRetencoes.js";

export default {
  data: () => ({
    loading: false,
    items: [],
    tableFooter: {
      "items-per-page-options": [5, 10, 15, 20],
      "items-per-page-text": "Linhas por página",
    },
    headers: [
      {
        text: "Data",
        sortable: false,
        value: "created_at",
      },
      {
        text: "Username",
        sortable: false,
        value: "username",
      },
      {
        text: "Opções",
        sortable: false,
        value: "actions",
        align: "center",
      },
    ],
  }),

  mounted() {
    this.getPrints();
  },

  methods: {
    getPrints() {
      this.loading = true;

      GarantiasRetencoes.getPrints(this.$route.params.id)
        .then((response) => {
          const data = Array.isArray(response?.data)
            ? response.data
            : (response?.data?.data ?? []);

          this.items = data.map((item) => ({
            ...item,
            username: item?.user?.name ?? "-",
          }));

          this.loading = false;
        })
        .catch(() => {
          this.items = [];
          this.loading = false;
        });
    },

    downloadPrint(item) {
      const url = item?.url || item?.download_url || item?.docx_path;

      if (!url) return;

      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      window.open(url, isStandalone ? '_self' : '_blank')
    },

    formatDate(date) {
      if (!date) return "-";

      const value = String(date).replace("T", " ");
      return value.slice(0, 19);
    },
  },
};
</script>